/**
 * 两个对象的合并
 * @param {*} targetObj
 * @param {*} sourceObj
 * @param {*} needNew 是否需要生成的新的对象，默认false, 直接merge到targetObj上
 * @param notCoverTarget 相同值的情况下不覆盖target，默认false, 在为true的情况，targetObj中的值不会被sourceObj覆盖
 * @returns
 */
export const mergeObj = (
  targetObj,
  sourceObj,
  { needNew, notCoverTarget } = {}
) => {
  let _targetObj = targetObj
  if (needNew) {
    _targetObj = JSON.parse(JSON.stringify(targetObj))
  }
  if (!notCoverTarget && Array.isArray(sourceObj)) {
    return sourceObj
  } else if (notCoverTarget && Array.isArray(_targetObj)) {
    return _targetObj
  }
  if (typeof _targetObj === 'object' && typeof sourceObj === 'object') {
    for (const i in sourceObj) {
      if (typeof _targetObj[i] === 'undefined') {
        _targetObj[i] = sourceObj[i]
      } else {
        const mRes = mergeObj(_targetObj[i], sourceObj[i], { notCoverTarget })
        if (!notCoverTarget) {
          _targetObj[i] = mRes
        }
      }
    }
  } else {
    _targetObj = sourceObj
  }
  return _targetObj
}

/**
 * 根据表达式查询值
 * @param {*} expr 表达式
 * @param {*} scope 指向
 */
export function getExprVal(expr, scope) {
  if (typeof expr !== 'string' || !expr?.trim?.()) {
    return
  }
  if (typeof scope !== 'object' || !scope || !Object.keys(scope).length) {
    return
  }
  const arr = expr.split('.')
  return arr.reduce((prev, cur) => {
    if (typeof prev !== 'undefined') {
      return prev[cur]
    }
    return undefined
  }, scope)
}
